import { memo } from 'react';
import { T } from '../../translation/src';
import { SuperadminOrganisationFragment } from '../../types/graphqlTypes';

interface RelationProps {
  label: React.ReactNode;
  // What "nobody" means for this relation: Pythagoras, or the organisation itself.
  noneLabel: React.ReactNode;
  link: { name: string } | null | undefined;
}
const Relation: React.FC<RelationProps> = ({ label, noneLabel, link }) => (
  <div className="flex flex-col gap-1">
    <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">{label}</span>
    <span className="text-sm font-semibold">{link ? link.name : noneLabel}</span>
  </div>
);

export interface PartnerRelationsPanelProps {
  referral: SuperadminOrganisationFragment['referral'];
}
// The organisation's commercial relations as a customer: who brought it in, who manages the relationship, whom
// Pythagoras invoices for it. Read only: they follow from linking it to a partner (the partner's link customers
// tab) and from that partner's role.
const PartnerRelationsPanel_: React.FC<PartnerRelationsPanelProps> = ({ referral }) => (
  <div className="flex flex-col gap-5">
    <Relation label={<T _str="acquired by" swc />} noneLabel={<T _str="direct (Pythagoras)" />} link={referral.acquiredBy} />
    <Relation label={<T _str="managed by" swc />} noneLabel={<T _str="Pythagoras" />} link={referral.managedBy} />
    <Relation label={<T _str="billed to" swc />} noneLabel={<T _str="the organisation itself" />} link={referral.billedTo} />
    <span className="max-w-xl text-xs text-gray-500">
      <T _str="Billed to a partner, the organisation cannot order itself. Its partner orders its plan, upgrades and projects and is invoiced for them. To change these, link the organisation to a partner from that partner's link customers tab." />
    </span>
  </div>
);
export const PartnerRelationsPanel = memo(PartnerRelationsPanel_);
